import { computed, inject, Injectable, signal } from '@angular/core';
import { OfficesService } from '../api/franchises.service';
import { RolesService } from '../api/roles.service';
import { DirectoryService } from '../api/directory.service';
import { DirectoryUser } from '@/models/directory-user.model';

@Injectable({ providedIn: 'root' })
export class OfficeUsersService {
    officeService = inject(OfficesService);
    rolesService = inject(RolesService);
    directoryService = inject(DirectoryService);

    officeUsers = signal<DirectoryUser[]>([]);

    selectedUser = signal<DirectoryUser | null>(null);

    showEditForm = signal<boolean>(false);

    officeIds = computed(() => {
        const offices = this.officeService.getFilteredOffices('Users', 'edit');
        return offices.map(o => o.FID);
    });

    getOfficeIds() {
        return this.officeIds();
      }
      
      getFilteredRoles() {
        const officeIds = this.getOfficeIds();
        const roles = this.rolesService.roles();
        return roles.filter(r => r.FID != null && officeIds.includes(r.FID));
      }

      searchDirectory(search: string) {
        const users = this.directoryService.userList();
        return users.filter(user => user.DisplayName.toLowerCase().includes(search.toLowerCase()) || user.User.toLowerCase().includes(search.toLowerCase()));
      }

      populateOfficeUsers(officeList: number[]) {
        this.directoryService.getFilteredUserList(officeList).subscribe(users => {
          this.officeUsers.set(users);
        });
      }

      setShowEditForm(show: boolean) {
        if (!show) {
          this.selectedUser.set(null);
        }
        this.showEditForm.set(show);
      }

}
